import React from 'react';
import styled from 'styled-components';

import { ClickAwayListener, Grow, MenuItem, MenuList, Popper } from '@material-ui/core';

import { useTranslation } from 'react-i18next';
import { LANGUAGES } from 'config/constants/language';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const LanguageSelect: React.FC = React.memo(() => {
	const [open, setOpen] = React.useState(false);
	const { i18n } = useTranslation();

	const anchorRef = React.useRef(null);

	const handleToggle = () => {
		setOpen((prevOpen) => !prevOpen);
	};

	const handleClose = (event: React.MouseEvent<EventTarget>) => {
		if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
			return;
		}

		setOpen(false);
	};

	const handleSelect = (event: React.MouseEvent<EventTarget>, code: string) => {
		i18n.changeLanguage(code);
		localStorage.setItem('lang', code);
		handleClose(event);
	};

	const handleListKeyDown = (event: React.KeyboardEvent) => {
		if (event.key === 'Tab') {
			event.preventDefault();
			setOpen(false);
		}
	};

	const selectedLanguage = LANGUAGES.find(
		(item) => item.code.toLowerCase() === i18n.language?.toLowerCase()
	);

	return (
		<>
			<StyledLanguageSection
				ref={anchorRef}
				aria-controls={open ? 'menu-lang-list' : undefined}
				aria-haspopup="true"
				onClick={handleToggle}
			>
				<img src={selectedLanguage?.logo} style={{ marginRight: 6 }} />
				{i18n.language?.substr(0, 2)}
				<ExpandMoreIcon />
			</StyledLanguageSection>

			<Popper
				open={open}
				anchorEl={anchorRef.current}
				placement="bottom-end"
				role={undefined}
				transition
				disablePortal
			>
				{({ TransitionProps, placement }) => (
					<Grow
						{...TransitionProps}
						style={{
							transformOrigin: placement === 'bottom-end' ? 'start top' : 'center bottom',
						}}
					>
						<StyledOptionContainer>
							<ClickAwayListener onClickAway={handleClose}>
								<MenuList
									autoFocusItem={open}
									id="menu-lang-list"
									onKeyDown={handleListKeyDown}
									className="wrap_list_language"
								>
									{LANGUAGES.map((item) => {
										return (
											<StyledMenuItem
												onClick={(event) => {
													handleSelect(event, item.code);
												}}
											>
												<img src={item?.logo} />
												{item.name}
											</StyledMenuItem>
										);
									})}
								</MenuList>
							</ClickAwayListener>
						</StyledOptionContainer>
					</Grow>
				)}
			</Popper>
		</>
	);
});

const StyledMenuItem = styled(MenuItem)`
	color: #fff !important;
	border-radius: 8px !important;
	width: 130px !important;

	&:hover {
		background: rgba(225, 225, 225, 0.2) !important;
	}
`;

const StyledLanguageSection = styled.div`
	text-transform: uppercase;
	margin: 4px 0px;
	position: relative;
	display: flex;

	box-sizing: border-box;
	align-items: center;
	cursor: pointer;
	justify-content: start;

	font-weight: bold;
	color: #fff;

	svg {
		font-size: 24px;
		margin-left: 4px;
	}
	@media (max-width: 780px) {
		font-size: 11px;
	}
`;
const StyledOptionContainer = styled.div`
	margin-top: 4px;
	border: 1px solid #272f52;
	display: flex;
	align-items: center;
	border-radius: 8px;
	background: linear-gradient(0deg, #191d25 -5.56%, #1a2233 108.98%);
	padding: 0px 8px;
	box-sizing: border-box;
	width: 100%;
	.wrap_list_language {
		display: grid;
		grid-template-columns: 1fr;
		gap: 0px 0px;
	}
`;

export default LanguageSelect;
